import { c as _c } from "react/compiler-runtime";
import { IcoBook16, IcoCirclePlay16 } from '@onefootprint/icons';
import { IconButton, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import NodeIcon from '@/components/playbook-builder/components/base-node/components/node-icon';
import SandboxToggle from '@/components/sandbox-toggle';
type TestPanelHeaderProps = {
  title: string;
  description: string;
  docHref: string;
};
export const TestPanelHeader = t0 => {
  const $ = _c(25);
  const {
    title,
    description,
    docHref
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "testMode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NodeIcon Icon={IcoCirclePlay16} color="primary" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <h2 className="text-label-2 text-primary truncate">{title}</h2>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SandboxToggle />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t(_temp2);
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== docHref) {
    t7 = () => window.open(docHref, "_blank", "noopener,noreferrer");
    $[9] = docHref;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <IconButton aria-label={t6} icon={IcoBook16} onClick={t7} variant="outline" size="compact" />;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <div className="flex items-center gap-2 shrink-0 -my-1">{t4}<Tooltip content={t5}>{t8}</Tooltip></div>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t3 || $[18] !== t9) {
    t10 = <div className="flex flex-wrap items-center justify-between gap-3 md:flex-nowrap">{t3}{t9}</div>;
    $[17] = t3;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== description) {
    t11 = <div className="text-body-2 text-tertiary">{description}</div>;
    $[20] = description;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <div className="flex gap-3 items-center border-b border-tertiary p-4 z-10 sticky top-0 bg-primary">{t2}<div className="flex grow flex-col gap-1 min-w-0">{t10}{t11}</div></div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};
function _temp($) {
  return $.testForm.seeDocumentation;
}
function _temp2($_0) {
  return $_0.testForm.seeDocumentation;
}